import { IFields } from "./types";

export const isAddDisabled = (fields: IFields, object: any) => {
  let isDisabled = false;
  fields.forEach((field) => {
    if (field.mandatory && !object[field.accessorKey]) {
      isDisabled = true;
    }
  });
  return isDisabled;
};
